import Vue from "vue";
import Vuex from "vuex";
import { IMobile } from "./modules/mobile";
import { IUiConfig } from "./modules/uiConfig";

Vue.use(Vuex);
export interface IRootState {
  mobile: IMobile;
  uiConfig: IUiConfig
}
// 各个模块之后会动态注册进来
export default new Vuex.Store<IRootState>({});